import React from 'react';
import Routes from './routes';

const SignInFlow = () => <Routes />;

export default SignInFlow;
